import { render, staticRenderFns } from "./AdRatio.vue?vue&type=template&id=8b3af656&"
import script from "./AdRatio.vue?vue&type=script&lang=js&"
export * from "./AdRatio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports